import { AllowedProductProfileDtoToEntity } from "src/app/features/AllowedProductProfile/services/mappers/AllowedProductProfileDtoToEntity";
import type { AllowedProductProfileDto } from "src/app/features/AllowedProductProfile/types/AllowedProductProfileDto";
import type { AllowedProductProfileEntity } from "src/app/features/AllowedProductProfile/types/AllowedProductProfileEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const AllowedProductProfileTableDtoMapper = (
    input: Readonly<ResourcePageDto<AllowedProductProfileDto>>,
): ResourcePageEntity<AllowedProductProfileEntity> => {
    return {
        list: input.list ? input.list.map(AllowedProductProfileDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
